import $ from 'jquery';
import _ from 'underscore';
import * as config from '../../home24/core/config';

function WishlistService() {
    this.urls = {
        add: config.getBaseUrl() + '/myaccount/wishlist/add',
        remove: config.getBaseUrl() + '/myaccount/wishlist/remove'
    };

    $.subscribe('add.wishlistService', this.onAdd.bind(this));
    $.subscribe('remove.wishlistService', this.onRemove.bind(this));
}

WishlistService.prototype = {

    /**
     * add sku to wishlist
     * @param sku
     * @returns Promise
     */
    add: function (sku) {
        return this._send('add', sku);
    },

    /**
     * remove sku from wishlist
     * @param sku
     * @returns Promise
     */
    remove: function (sku) {
        return this._send('remove', sku);
    },

    onAdd: function (e, data) {
        this._send('add', data.sku);
    },

    onRemove: function (e, data) {
        return this._send('remove', data.sku);
    },

    _send: function (action, sku) {
        return this._sendAjax(action, sku).done(function (data) {

            if (data && _.isNumber(data.wishlistItemsCount)) {
                $.publish('update.wishlist:counter', data);
            }

            if (action === 'add') {
                $.publish('added.wishlistService', { sku: sku });
            } else if (action === 'remove') {
                $.publish('removed.wishlistService', { sku: sku });
            }


            return data;
        });
    },

    _sendAjax: function (action, sku) {
        return $.ajax({
            method: 'POST',
            url: this.urls[action],
            dataType: 'json',
            data: {
                sku: sku
            }
        });
    }
};

const wishlistService = new WishlistService();

export function add(sku) {
    return wishlistService.add(sku);
}

export function remove(sku) {
    return wishlistService.remove(sku);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/wishlist/wishlistService.js
 **/